/**
 * Header — Mobile menu, search toggle, mega menu keyboard nav
 */
(function () {
  'use strict';

  const header = document.querySelector('.header');
  if (!header) return;

  /* Mobile menu toggle */
  const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
  const mobileNav = header.querySelector('[data-mobile-nav]');
  const iconMenu = header.querySelector('.header__icon-menu');
  const iconClose = header.querySelector('.header__icon-close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);

      if (iconMenu && iconClose) {
        iconMenu.classList.toggle('hidden', isOpen);
        iconClose.classList.toggle('hidden', !isOpen);
      }

      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    /* Close button inside mobile nav */
    const mobileNavClose = header.querySelector('[data-mobile-nav-close]');
    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileNav.setAttribute('aria-hidden', 'true');
        if (iconMenu && iconClose) {
          iconMenu.classList.remove('hidden');
          iconClose.classList.add('hidden');
        }
        document.body.style.overflow = '';
      });
    }

    /* Close on overlay click */
    SixSeven.on(SixSeven.Events.OVERLAY_HIDE, () => {
      mobileNav.classList.remove('is-open');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (iconMenu && iconClose) {
        iconMenu.classList.remove('hidden');
        iconClose.classList.add('hidden');
      }
    });
  }

  /* Mobile submenu toggles */
  const submenuToggles = header.querySelectorAll('[data-mobile-submenu-toggle]');
  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
    });
  });

  /* Search toggle */
  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchOverlay = header.querySelector('[data-header-search]');
  const searchClose = header.querySelector('[data-search-close]');
  const searchInput = header.querySelector('[data-search-input]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    SixSeven.emit(SixSeven.Events.OVERLAY_SHOW);
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 300);
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    SixSeven.emit(SixSeven.Events.OVERLAY_HIDE);
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', openSearch);
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  /* Close search on overlay click */
  SixSeven.on(SixSeven.Events.OVERLAY_HIDE, () => {
    if (searchOverlay && searchOverlay.classList.contains('is-open')) {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
    }
  });

  /* Escape key */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        SixSeven.emit(SixSeven.Events.OVERLAY_HIDE);
      }
    }
  });

  /* Cart icon — prevent default if cart drawer enabled */
  const cartToggle = header.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      const cartType = document.body.dataset.cartType;
      if (cartType === 'drawer') {
        e.preventDefault();
        SixSeven.emit('cart:toggle');
      }
    });
  }
})();
